import { callService, serviceReducer } from "../../hooks/serviceReducer";
import { Action, ApiState } from "../../misc/api.types";
import { PagedFilterObservations } from "../../misc/pagedFilter";
import { ObservationResult } from "../../models/observation.model";


export type ResultAction =
  | Action<ObservationResult>
  | { type: "PAGE"; value: number }
  | { type: "PAGE_SIZE"; value: number }
  | { type: "SEARCH"; value: PagedFilterObservations }
  | { type: "ORDER"; column: string; sortDescending: boolean };

const reducer = (
  state: ApiState<ObservationResult, PagedFilterObservations>,
  action: ResultAction
): ApiState<ObservationResult, PagedFilterObservations> => {
  switch (action.type) {
    case "PAGE": {
      return callService(state, { ...state.filter, pageNumber: action.value });
    }
    case "PAGE_SIZE": {
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        pageSize: action.value,
      });
    }
    case "SEARCH": {
      return callService(state, { ...state.filter, ...action.value });
    }
    case "ORDER": {
      return callService(state, {
        ...state.filter,
        sortField: action.column,
        sortDescending: action.sortDescending,
      });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;